var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('page-title',{attrs:{"title":"Carpooling","subtitle":"Manage all the carpooling routes in the organization"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }